import { Icon } from '../Icon';
import { NEED_ORDER, moodLabel } from './logic';

export function Clock({ bridge, onRender }) {
    onRender?.('clock');
    const { hour } = bridge.clock.value;
    const h = Math.floor(hour);
    const m = Math.floor((hour - h) * 60);
    return <span class="chip is-static hud-clock" aria-label="Time">{`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`}</span>;
}

export function Wallet({ bridge, onRender }) {
    onRender?.('wallet');
    return <span class="chip is-static hud-wallet" aria-label="Naira balance">{`₦${bridge.wallet.value.naira.toLocaleString('en-NG')}`}</span>;
}

/** Floating +/- amounts next to the wallet; `floaters` is the signal from createFloaters. */
export function WalletFloaters({ floaters }) {
    return (<span class="hud-floaters" aria-hidden="true">
      {floaters.value.map((f) => (<span key={f.id} class={`floater is-${f.sign}`}>{f.text}</span>))}
    </span>);
}

export function Needs({ bridge, onRender }) {
    onRender?.('needs');
    const n = bridge.needs.value;
    return (<div class="hud-needs" role="group" aria-label="Needs">
      {NEED_ORDER.map((k) => {
        const v = Math.max(0, Math.min(100, n[k]));
        const label = moodLabel(k, v);
        return (<div key={k} class="need" data-need={k} role="meter" aria-label={`${k}: ${label}`} aria-valuemin="0" aria-valuemax="100" aria-valuenow={Math.round(v)} style={`--c:var(--need-${k})`}>
          <span class="need-label">{label}</span>
          <span class="need-track"><i style={`width:${v}%`}/></span>
        </div>);
      })}
    </div>);
}

const POWER = {
  grid: { icon: 'bulb', label: 'NEPA: light dey' },
  gen: { icon: 'bulb', label: 'Generator on' },
  off: { icon: 'lightbulb-off', label: 'NEPA: light don go' },
};
export function PowerGlyph({ bridge, onRender }) {
    onRender?.('power');
    const p = bridge.power.value;
    return <span class={`chip is-static hud-power is-${p}`} role="img" aria-label={POWER[p].label}><Icon name={POWER[p].icon}/></span>;
}

export function OnlineChip({ bridge }) {
    const on = !!bridge.me.value?.online;
    return (<span class={`chip is-static hud-online ${on ? 'is-on' : 'is-off'}`} role="img" aria-label={on ? 'Online' : 'Offline'}>
      <Icon name={on ? 'wifi01' : 'wifi-off01'}/>
    </span>);
}

/** Badge is drawn by CSS from the `data-unread` attribute that the phone module writes (phone.css). */
export function PhoneButton({ bridge }) {
    return (<button type="button" class="chip hud-phone" data-id="phone" aria-label="Phone" onClick={() => bridge.openPhone()} onPointerDown={(e) => e.stopPropagation()}>
      <Icon name="smart-phone01"/>
    </button>);
}
